import React from 'react'
import styled from 'styled-components'
import { Text } from '@sketch/components'

const Opacity = styled(Text.Span).attrs({
  textStyle: 'copy.quaternary.standard.D',
})`
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  margin-right: 4px;
`

const OpacityPercentage = ({ value: opacity }: { value?: number }) =>
  (opacity && opacity < 1) || opacity === 0 ? (
    <Opacity>{`${(opacity * 100).toFixed()}%`}</Opacity>
  ) : null

export default OpacityPercentage
